import { render, staticRenderFns } from "./InboundSettings.vue?vue&type=template&id=7812d95b&scoped=true&"
import script from "./InboundSettings.vue?vue&type=script&lang=js&"
export * from "./InboundSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7812d95b",
  null
  
)

/* custom blocks */
import block0 from "./InboundSettings.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports